import { getCookie } from 'react-simple-cookie-store';
import { AccessToken } from './AccessToken';
export var getRefreshToken = function () {
    var token = getCookie(AccessToken.Refresh);
    return token || '';
};
